import { defineMessages } from 'react-intl';

export default defineMessages({
    monthlyInterestRate: {
        id: '_.dashboard.approved.credit_utilisation.monthly_interest_rate',
        defaultMessage: '{monthlyInterestRate} interest per 30 days'
    },
    creditUtilisationOutstandingMessageWithInterest: {
        id: '_.dashboard.approved.credit_utilisation_outstanding_message_with_interest',
        defaultMessage: 'You owe {interestBalance} in interest'
    },
    creditUtilisationOutstandingMessageWithInterestAndFees: {
        id: '_.dashboard.approved.credit_utilisation_outstanding_message_with_interest_and_fees',
        defaultMessage:
            'You owe {interestBalance} in interest and {feesBalance} in fees'
    }
});
